import { render, staticRenderFns } from "./unionIntroduce.vue?vue&type=template&id=01a3b32e&scoped=true"
import script from "./unionIntroduce.vue?vue&type=script&lang=js"
export * from "./unionIntroduce.vue?vue&type=script&lang=js"
import style0 from "./unionIntroduce.vue?vue&type=style&index=0&id=01a3b32e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3b32e",
  null
  
)

export default component.exports